import { Home, Wrench, BookOpen, Info, Phone } from "lucide-react";
import { useLocation, Link } from "react-router-dom";

const MobileNav = () => {
  const location = useLocation();

  const isActive = (path: string): boolean => location.pathname === path;

  return (
    <section className="grid-padding-lr">
      <nav className="navbar-bottom">
        <div className="navbar-mobile navbar-visible">
          <ul className="navbar-links flex-row align-items-center space-around">
            <li className={`bg-primary-color ${isActive("/") ? "active" : ""}`}>
              <Link to="/" aria-label="Home">
                <Home size={24} color="#fff" />
              </Link>
            </li>
            <li
              className={`bg-primary-color ${
                isActive("/diensten") ? "active" : ""
              }`}
            >
              <Link to="/diensten" aria-label="Services">
                <Wrench size={24} color="#fff" />
              </Link>
            </li>
            <li
              className={`bg-primary-color ${
                isActive("/realisaties") ? "active" : ""
              }`}
            >
              <Link to="/realisaties" aria-label="References">
                <BookOpen size={24} color="#fff" />
              </Link>
            </li>
            <li
              className={`bg-primary-color ${
                isActive("/overons") ? "active" : ""
              }`}
            >
              <Link to="/overons" aria-label="About">
                <Info size={24} color="#fff" />
              </Link>
            </li>
            <li
              className={`bg-primary-color ${
                isActive("/contact") ? "active" : ""
              }`}
            >
              <Link to="/contact" aria-label="Contact">
                <Phone size={24} color="#fff" />
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </section>
  );
};

export default MobileNav;
